import { TourRenderer } from "@bcc/components/tour/tour-renderer/tour-renderer";
import { Toaster } from "@bcc/components/ui/toast/toaster";
import { RBACProvider } from "@bcc/contexts/rbac-context";
import { TourProvider } from "@bcc/contexts/tour-context";
import AppRoutes from "./AppRoutes";
import "./lib/i18n";

const App = () => (
  <div className="min-h-screen bg-background text-foreground">
    <RBACProvider>
      <TourProvider>
        <AppRoutes />
        <TourRenderer />
      </TourProvider>
    </RBACProvider>
    <Toaster />
  </div>
);

App.displayName = "BeanzConnect";

export default App;
